import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
const EventAuthFooter = ({ logoPosition = "start", showCredits = false, }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isBelow1024 = useMediaQuery("(max-width:1025px)");
    const isBelow390 = useMediaQuery("(max-width:391px)");
    const isMediumScreen = useMediaQuery("(max-width:901px)");
    return (_jsxs(Box, { position: "relative", zIndex: 5, bottom: 0, width: "100%", display: "flex", flexDirection: "column", gap: 3, mt: 2.5, sx: {
            backgroundImage: "linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 100%)",
        }, children: [_jsx("img", { src: isMediumScreen
                    ? "/assets/images/vdk-logo-small.svg"
                    : "/assets/images/vdk-logo-big.svg", width: "100%", height: "auto", alt: "large-low-brand-bar", style: {
                    padding: isMediumScreen ? "0 20px" : 0,
                    marginLeft: isMediumScreen
                        ? "auto"
                        : logoPosition === "start"
                            ? 120
                            : 0,
                    marginRight: isMediumScreen
                        ? "auto"
                        : logoPosition === "end"
                            ? 120
                            : 0,
                    maxWidth: isMediumScreen ? 350 : 387,
                    alignSelf: logoPosition === "start" ? "flex-start" : "flex-end",
                } }), _jsx(Typography, { variant: "body2", color: "white", fontSize: 8, fontWeight: 400, sx: {
                    zIndex: 5,
                    opacity: 0.2,
                    marginLeft: isMediumScreen
                        ? "auto"
                        : logoPosition === "start"
                            ? "120px"
                            : 0,
                    marginRight: isMediumScreen
                        ? "auto"
                        : logoPosition === "end"
                            ? "120px"
                            : 0,
                    [theme.breakpoints.down(901)]: {
                        position: "static",
                        display: "flex",
                        alignSelf: "center",
                        marginTop: 2,
                    },
                    maxWidth: isMediumScreen ? 350 : 387,
                    width: "100%",
                    alignSelf: logoPosition === "start" ? "flex-start" : "flex-end",
                }, textAlign: "center", children: t("event.credits") }), _jsx("img", { src: isBelow390
                    ? "/assets/images/lowBrandBar/small.png"
                    : isBelow1024
                        ? "/assets/images/lowBrandBar/medium.png"
                        : "/assets/images/LowBrandBar.png", width: "100%", alt: "large-low-brand-bar", style: {
                    position: "relative",
                    height: isBelow390 ? 80 : isBelow1024 ? 85.33 : 96,
                } })] }));
};
export default EventAuthFooter;
